// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"717":"93fbecfe","794":"5a3922d9"}[chunkId] + ".chunk.css";
};